import axios from 'axios';

const getList = params => axios.get('/grupo-produtos-gestao', {
  params,
});
const get = id => axios.get(`/grupo-produtos-gestao/${id}`, {});

const save = (grupo) => {
  if (grupo.id) {
    return axios.put(`/grupo-produtos-gestao/${grupo.id}`, grupo);
  }
  return axios.post('/grupo-produtos-gestao', grupo);
};

const remover = id => axios.delete(`/grupo-produtos-gestao/${id}`);

export default {
  getList,
  get,
  save,
  remover,
};
